module.exports = __webpack_public_path__ + "img/shezhi_active.2a2a381b.png";